import React from 'react';
import { useLocation } from 'react-router-dom';

import Tippy from '@tippyjs/react';

import { mString } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

import { resolveAmountPaidSelf } from './lib/amountPaidSelf';

const AmountPaidSelf = ({ value, data }) => {
  const location = useLocation();
  // Beyond Billing is also mounted in the admin Practice Viewport (/admin/practices/:id/...).
  const isFromBB = location?.pathname?.includes('/beyond-billing');

  const { finalAmount, totalRefunded, surcharge, gratuity } = resolveAmountPaidSelf({
    value,
    data,
    isFromBB
  });

  const isRefunded = totalRefunded > 0;
  const refundedDisplay = mString(totalRefunded);
  const chargeTooltip = mString(finalAmount - surcharge - gratuity);
  const surchargeTooltip = mString(surcharge);

  return (
    <Tippy
      className="tippy-dark"
      content={
        <div className="flex flex-col gap-1">
          <Typography variant="span" size="small" color="white">
            Charge: <span>{chargeTooltip}</span>
          </Typography>
          <Typography variant="span" size="small" color="white">
            Technology fee: <span>{surchargeTooltip}</span>
          </Typography>
          {gratuity > 0 && (
            <Typography variant="span" size="small" color="white">
              Tip: <span>{mString(gratuity)}</span>
            </Typography>
          )}
        </div>
      }>
      <div className="flex h-full items-center gap-1">
        <Typography variant="span" size="small" color="neutral-800">
          {mString(finalAmount)}
        </Typography>
        {isRefunded && (
          <Typography variant="span" size="small" color="neutral-800" className="gap-0">
            (Refunded:<span className="pl-1 font-bold">-{refundedDisplay}</span>)
          </Typography>
        )}
      </div>
    </Tippy>
  );
};

export default AmountPaidSelf;
